export default "__VITE_ASSET__7594e27a__"